import {AthleteViewModel} from "../../../../common/athlete/athlete-view-model";

export class AthleteChartEventsAthleteViewModel extends AthleteViewModel {

  get entityLogoSize(): Number {
    const entityLogoSize = {
      desktop: 56,
      mobile:  54
    };

    return entityLogoSize;
  }}
